$(document).ready(function(){
  new WOW().init();
  	$(window).on("resize", function (e) {
        checkScreenSize();
    });

  // Related Slider

    $(document).on("click", ".prev_trigger_btn", function() {
            $(this).closest("section").find(".owl-prev").trigger("click");

        });
        $(document).on("click", ".next_trigger_btn", function() {
            $(this).closest("section").find(".owl-next").trigger("click");
        });
  
  jQuery(".facets__disclosure span").click(function(e){
     jQuery(this).closest(".col_list").find("ul").slideToggle();
     jQuery(this).toggleClass("toggle_rotate");
   });

  // Video Popup Js

  $('#poup-video').modal({
        show: false
    }).on('hidden.bs.modal', function(){
        $(this).find('video')[0].pause();
    });

  
   jQuery(".video-container video").on("pause", function (e) {
    jQuery(this).closest(".video-container").find(".play-gif").fadeIn(500);
});
   jQuery(".video-container video").on("play", function (e) {
    jQuery(this).closest(".video-container").find(".play-gif").fadeOut(500);
});

  $(function() {
  var owl = $("#text_rotation");
  owl.owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 4000,
    smartSpeed: 3000,
    autoHeight:true,
    animateOut: "slideOutUp",
    animateIn: "slideInUp",
  });
});
  
  $('#review_carousal').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:true,
		autoHeight: true,
		nav:true,
		pagination:false,  dots: true,
		navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:1
	        },
	        1024:{
	            items:1
	        },
	        1100:{
	            items:2
	        }
	    }
	}); 

  $('.feature-slider').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 5000,
		paginationSpeed : 400,
		autoplay:true,
		nav:true,
		pagination:false,  dots: false,
		navText: ["<img src='https://cdn.shopify.com/s/files/1/0848/8114/6153/files/Vector_lefts.png'>","<img src='https://cdn.shopify.com/s/files/1/0848/8114/6153/files/Vector_rights.png'>"],
	    responsive:{
	        0:{
	            items:2
	        },
	        480:{
	            items:2
	        },
	        768:{
	            items:3
	        },
	        991:{
	            items:4
	        },
	        1100:{
	            items:5
	        }
	    }
	});

    
  
	 
});
